module.exports = __webpack_public_path__ + "static/media/refresh.10387805.svg";